module.exports = __webpack_public_path__ + "img/chart-upwards.5b4d284a.svg";